import { handleActions, combineActions } from 'redux-actions';
import { LOAD_USER_MODIFY } from '../constants';

const intialState = {
  loading: false,
  model: null,
  error: false,
};

const modifyReducer = handleActions(
  {
    [LOAD_USER_MODIFY.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_USER_MODIFY.CANCELLED,
      LOAD_USER_MODIFY.SUCCESS,
      LOAD_USER_MODIFY.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_USER_MODIFY.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_USER_MODIFY.ERROR]: state => ({
      ...state,
      error: true,
    }),
    [LOAD_USER_MODIFY.CLEAR]: () => intialState
  },
  intialState,
);

export default modifyReducer;
